import React, { useState } from 'react';
import './DecisionExecutionForm.css';
import { API_BASE_URL } from '../config';

const DecisionExecutionForm = ({ onRunComplete, setIsLoading, onUnauthorized }) => {
  const [formData, setFormData] = useState({
    eventId: '',
    thesisId: '',
    marketId: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.eventId || !formData.thesisId || !formData.marketId) {
      setError('Todos os campos são obrigatórios');
      return;
    }

    if (!uuidRegex.test(formData.eventId) || !uuidRegex.test(formData.thesisId) || !uuidRegex.test(formData.marketId)) {
      setError('Os IDs devem estar no formato UUID válido');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/decision/run`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      });

      if (response.status === 401) {
        setError('Sessão expirada. Faça login novamente.');
        if (onUnauthorized) {
          onUnauthorized();
        }
        return;
      }

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Erro ao executar decisão');
      }

      setSuccess('Decisão executada com sucesso');
      if (onRunComplete) {
        onRunComplete(data);
      }

      setFormData({ eventId: '', thesisId: '', marketId: '' });
    } catch (err) {
      setError(err.message || 'Erro ao conectar com a API');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="decision-execution-form">
      <div className="form-header">
        <h2>Executar Decisão</h2>
      </div>

      <form onSubmit={handleSubmit} className="execution-form">
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="eventId" className="form-label">Event ID</label>
            <input id="eventId" name="eventId" value={formData.eventId} onChange={handleChange} className="form-input" required />
          </div>

          <div className="form-group">
            <label htmlFor="thesisId" className="form-label">Thesis ID</label>
            <input id="thesisId" name="thesisId" value={formData.thesisId} onChange={handleChange} className="form-input" required />
          </div>

          <div className="form-group">
            <label htmlFor="marketId" className="form-label">Market ID</label>
            <input id="marketId" name="marketId" value={formData.marketId} onChange={handleChange} className="form-input" required />
          </div>
        </div>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={!formData.eventId || !formData.thesisId || !formData.marketId}>
            Executar Decisão
          </button>
        </div>
      </form>
    </div>
  );
};

export default DecisionExecutionForm;
